const getters = {
	revealStates(state) {
		return key => state[key];
	},
};

export default getters;



// WEBPACK FOOTER //
// ./scripts/sky-reveal/store/getters.js